export const SKELETON_VARIANTS = {
  RECTANGULAR: 'rectangular',
  CIRCULAR: 'circular',
  TEXT: 'text',
};
